import { API_BASE_URL, IMAGE_PROXY_URL } from '@/constants/env';
import cx from 'classnames';
import NextImage from 'next/image';

export default function Image({ className, src, ...props }) {
  let objectFit = 'none';
  if (className?.includes('object-cover')) objectFit = 'cover';
  if (className?.includes('object-contain')) objectFit = 'contain';
  if (className?.includes('object-fill')) objectFit = 'fill';

  return (
    <div className={cx('relative', className)}>
      <NextImage
        unoptimized
        blurDataURL={API_BASE_URL.concat('/images?url=', src)}
        layout="fill"
        objectFit={objectFit}
        placeholder="blur"
        src={`${IMAGE_PROXY_URL}${src}`}
        {...props}
      />
    </div>
  );
}
